var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMicDisabled = function SvgMicDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164 164"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 20.5c-6 1.9-11.3 6.5-14.2 12.2-2.2 4.5-2.3 6.1-2.6 27.8-.2 12.6 0 24 .5 25.2.8 2.1 3 .1 26.2-23.1l25.3-25.3-2.6-5.1c-1.4-2.8-4.1-6.3-6-7.7-6.8-5.2-17.5-6.8-26.6-4zM80 71.9c-26.9 27-49 49.8-49 50.6 0 5.5 4.1 1.9 52.6-46.6 28.2-28.2 49.3-50 49.2-50.9-.9-4.5-5.1-.8-52.8 46.9zM86.1 79.3l-22.3 22.4L67 104c6.7 4.8 16.7 6.2 25.4 3.6 6.4-1.9 10.6-5.4 13.9-11.4 2.7-5 2.7-5.2 2.5-22.1l-.3-17.1-22.4 22.3zM43.7 72.6C41.5 74.8 44.5 99 47 99c.4 0 1.4-.8 2.4-1.9 1.4-1.5 1.5-2.3.5-4.7-.6-1.6-1.4-6.7-1.8-11.4-.5-6.5-1-8.5-2.1-8.8-.9-.1-1.9 0-2.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.7 72.6c-.4.4-.7 3.5-.7 6.9 0 7.6-2.3 15.5-6.2 21.7-10.7 17-35.6 21-52 8.5-3.4-2.6-3.5-2.7-5.2-.8-1.6 1.8-1.5 2 1.5 4.5 5 4.2 11.4 7.1 20.2 9l2.7.6v9.9c0 7.5.4 10.1 1.5 11.1 1.2 1 1.8 1 3 0 1.1-1 1.5-3.6 1.5-11.1V123l2.8-.6c9.7-2.1 15.8-5.1 21.7-10.5 9.3-8.6 13.8-19.4 13.3-32.1-.2-5.6-.7-7.3-1.8-7.6-.9-.1-1.9 0-2.3.4z"
  }))));
};

export default SvgMicDisabled;